module.exports = __webpack_public_path__ + "statics/adminassets/img/avatar2.929b19fe.jpg";